import { RpcService } from 'rpc';

export type FormData = Record<string, any>;

export declare interface IRCSService extends RpcService {
	login_survey(params: { formdata: FormData }): Promise<any>;
	quick_comment(params: { formdata: FormData }): Promise<any>;
	evaluation(params: { formdata: FormData }): Promise<any>;
}

const svc: IRCSService = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@form-proc.rpc`,

	services: {
		login_survey: {
			parameters: [
				{
					name: 'formdata',
					type: 'object',
					optional: false
				}
			]
		},
		quick_comment: {
			parameters: [
				{
					name: 'formdata',
					type: 'object',
					optional: false
				}
			]
		},
		evaluation: {
			parameters: [
				{
					name: 'formdata',
					type: 'object',
					optional: false
				}
			]
		}
	}
}) as IRCSService;

export default svc;
